import type { FaqItem, OfferItem, PainPoint, Testimonial } from '../types/sales'

export const checkoutUrl = 'https://unas-listas-para-siempre.impultienda.ar/checkout'

export const price = {
  today: '$19.990',
  bonusesTotal: '$43.500',
  monthlyGoal: '$1.500.000',
  minKit: '$50.000',
  setPrice: '$45.000',
}

export const painPoints: PainPoint[] = [
  {
    title: 'Cobrás demasiado poco',
    body: 'Hacés sets completos por $10.000 o $15.000 porque tenés miedo de perder a la clienta si subís el precio. Trabajás horas y horas y a fin de mes los números no cierran.',
  },
  {
    title: 'Tu Instagram no convierte',
    body: 'Publicás fotos de uñas todos los días y no llegan clientas nuevas. Solo likes de conocidas que nunca pagan ni reservan una cita.',
  },
  {
    title: 'Miedo a no ser suficientemente buena',
    body: 'Sentís que no estás lista para cobrar más caro. Siempre buscás otro curso, otro tutorial, otra técnica antes de dar el salto definitivo.',
  },
  {
    title: 'Sin tiempo libre real',
    body: 'Trabajás muchas horas sin un sistema claro. Dependés de que las clientas te recomienden y vivís con la incertidumbre de no saber cuánto vas a ganar el mes que viene.',
  },
]

export const testimonials: Testimonial[] = [
  {
    quote:
      'Antes cobraba $15.000 por set y apenas llegaba a fin de mes. Apliqué lo de precios de lujo y hoy mi tarifa mínima es de $45.000. Tengo la agenda llena con 3 semanas de anticipación.',
    name: 'Carla R.',
    role: 'Emprendedora desde casa',
    country: 'Colombia',
    result: 'Ingresos x3 en 30 días',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/ba454f4a-d70d-4831-8845-7a0aa7efd42e.jpg',
  },
  {
    quote:
      'Pensé que necesitaba un salón físico para ser profesional. Con la parte de Instagram conseguí mis primeras 8 clientas nuevas en una semana sin pagar publicidad.',
    name: 'Valentina M.',
    role: 'Ex empleada de retail',
    country: 'México',
    result: '8 clientas nuevas en 7 días',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/a1ddd1d7-11d8-4a74-86ad-300db2241b8a.jpg',
  },
  {
    quote:
      'Empecé sin saber absolutamente nada. El método es tan claro que a la semana ya estaba haciendo uñas en clientas reales. Hoy trabajo desde mi casa y gano más que en mi trabajo anterior.',
    name: 'Daniela T.',
    role: 'Emprendedora nail art',
    country: 'Argentina',
    result: 'Renunció a su trabajo en 45 días',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/b704b860-a35f-441f-bf3b-7d2951db97ed.jpg',
  },
]

export const bonuses: OfferItem[] = [
  {
    kind: 'bonus',
    label: 'Bono 1',
    title: 'Tratamiento de Sellado Térmico',
    description: 'Blindaje térmico que mantiene el brillo espejo intacto durante 30 días exactos.',
    value: '$6.900',
    tag: 'Gratis',
  },
  {
    kind: 'bonus',
    label: 'Bono 2',
    title: 'Terapia de Hidratación Profunda',
    description:
      'Masaje regenerador con óleo de cutícula para cerrar cada cita como una experiencia VIP.',
    value: '$8.900',
    tag: 'Gratis',
  },
  {
    kind: 'bonus',
    label: 'Bono 3',
    title: 'Emergency Nail-Fix Kit',
    description: 'Kit de emergencia miniatura para proteger la manicura ante cualquier imprevisto.',
    value: '$4.900',
    tag: 'Gratis',
  },
  {
    kind: 'bonus',
    label: 'Bono 4',
    title: 'Diseño según tu Tono de Piel',
    description:
      'Visagismo de manos: forma, largo y colores que de verdad favorecen a cada clienta.',
    value: '$9.900',
    tag: 'Gratis',
  },
  {
    kind: 'bonus',
    label: 'Bono 5',
    title: "Garantía Total 'Diamond Shield' de 7 Días",
    description: 'Cita de reparación prioritaria gratis si algo sale mal en los primeros 7 días.',
    value: '$12.900',
    tag: 'Gratis',
  },
]

export const faqs: FaqItem[] = [
  {
    question: '¿Necesito materiales caros para arrancar?',
    answer:
      'Para nada. Incluimos una lista de materiales “Smart Start” validada para que puedas empezar a practicar con menos de $50.000. Te decimos exactamente qué comprar, dónde conseguirlo y por qué esos específicos.',
  },
  {
    question: '¿Qué pasa si no tengo ninguna experiencia previa?',
    answer:
      'El método está diseñado desde cero absoluto. Te llevamos paso a paso desde cómo preparar correctamente la uña natural hasta cómo hacer diseños avanzados de nail art. No importa si nunca agarraste una lima en tu vida.',
  },
  {
    question: '¿Cuánto tardo en tener mis primeras clientas?',
    answer:
      'Si seguís el plan de 21 días, en la tercera semana ya deberías estar atendiendo tu primera clienta real y cobrando por eso. Las alumnas que aplican la parte de marketing suelen conseguir sus primeras citas en 7 a 10 días.',
  },
  {
    question: '¿Necesito un local o un espacio grande en casa?',
    answer:
      'No. El sistema está pensado para emprendedoras que trabajan desde casa. Con una mesa, buena luz y los materiales correctos tenés todo lo necesario para dar un servicio premium.',
  },
  {
    question: '¿Cómo funciona exactamente la garantía?',
    answer:
      'Tenés 7 días completos para ver todo el contenido, aplicar las técnicas y decidir con total calma. Si por cualquier razón sentís que esto no es para vos, me escribís y te devolvemos el 100% de tu plata. Sin preguntas, sin formularios, sin demoras. El riesgo es completamente nuestro.',
  },
]

export const pathA: string[] = [
  'Cobrar poco por miedo a perder clientas',
  'Seguir sin un sistema real para atraer clientas',
  'Invertir en materiales sin ver retorno',
  'Ver a otras crecer mientras vos seguís esperando el momento perfecto',
  'Seguir dependiendo de un jefe y de un horario que no elegiste',
]

export const pathB: string[] = [
  'Dominar la técnica más pedida del mercado en 2026',
  'Llenar tu agenda con clientas que pagan lo que valés',
  'Cobrar $45.000 o más por set con total confianza y sin culpa',
  'Trabajar desde casa en los horarios que vos decidís',
  'Generar $1.500.000 por mes de forma consistente y predecible',
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/5ddabc8d-7999-4457-bb05-4f03a688d98f.jpg',
  workspace:
    'https://cdn.magicpatterns.com/patterns/generated-images/404efd7b-0239-4ee7-b716-08d4841e9460.jpg',
}
